import React from 'react';

import Common from './Common';

import utmStorageUtil from '../utils/utmStorage';
import { referrerStorageSetup } from '../utils/referrerStorage';

export default function Layout(props) {
  React.useEffect(() => {
    utmStorageUtil();
    referrerStorageSetup();
  }, []);

  return <Common {...props} />;
}
